// extracted by mini-css-extract-plugin
module.exports = {"Card":"Profile_Card__3x3--"};